import React, {useEffect, useState} from 'react'

const initialState = {
  name: process.env.REACT_APP_NAME,
  version: process.env.REACT_APP_VERSION
}

export const AppContext = React.createContext(initialState)

export const AppProvider = ({ children }) => {
  
  const [logo, setLogo] = useState('none')

  useEffect(() => {
    import(`../assets/${process.env.REACT_APP_LOGO}`).then(image => {
      setLogo(image.default)
    })
  }, [])

  
  return <AppContext.Provider value={{
      ...initialState,
      logo
    }}>
      {children}
    </AppContext.Provider>
}